export const REGISTRATION_CLOSED_USER_MESSAGE =
  'As inscrições estão encerradas no momento.';

export const REGISTRATION = {
  closedButtonLabel: 'Inscrições Encerradas',
  closedUserMessage: REGISTRATION_CLOSED_USER_MESSAGE,
};

export default REGISTRATION;
